import { gql } from '@apollo/client/core';

export const TICKET_FRAGMENT = gql`
    fragment TicketFragment on Ticket {
        id
        subject
        status
        priority
        created_at
        category { name }
        sender {
            ... on User { id name }
            ... on Student {
                id
                surname
                first_name
            }
        }
    }
`;
